import React, { useState } from 'react';
import { useT } from '../i18n';

const MAX_SHOWN = 4;

// ── STYLE LIST ───────────────────────────────────────────────────────────────
// A designer's styles, capped at four with the rest behind a "+N" chip.
//
// Shared by the public profile and the owner's dashboard header — both rendered
// the same markup, and a cap applied to only one of them would have made the
// same designer look different depending on who was looking.
//
// The overflow chip is a BUTTON, not a link or a bare count: it is the control
// that reveals the rest, and it has to be obvious that pressing it does
// something. Once expanded it turns into "−", so the action is reversible.
//
// `prefix` / `moreLabel` are what let a SHOP reuse this for its categories.
// The two lists are the same thing — a capped row of chips naming what someone
// does — and they differ only in which i18n keys the entries resolve through.
export default function StyleList({ styles, prefix = 'ds_style_', moreLabel = 'ds_styles' }) {
  const { t } = useT();
  const [open, setOpen] = useState(false);

  if (!styles?.length) return null;

  const hidden = styles.length - MAX_SHOWN;
  const shown = open ? styles : styles.slice(0, MAX_SHOWN);

  return (
    <ul className="dph-styles">
      {shown.map(s => <li key={s} className="dph-style">{t(`${prefix}${s}`)}</li>)}
      {hidden > 0 && (
        <li>
          <button
            type="button"
            className="dph-style dph-style--more"
            onClick={() => setOpen(o => !o)}
            aria-expanded={open}
          >{open ? `− ${t(moreLabel)}` : `+${hidden}`}</button>
        </li>
      )}
    </ul>
  );
}
